import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';

import { db } from '../../firebase/index';


const StyleList = styled.div`
  display: flex;
  // flex-direction: row;
  flex-wrap:wrap;
  align-items: center;
  justify-content: center;
  max-width: 400px;
  margin: 0 auto;

  .style {
    width: 45%;
    padding: 5px;
    max-width: 200px;
  }

  & img {
    width: 100%;
  }
`

class SelectStyle extends Component {
  state = {
    styles: null,
    styleId: null,
  }
  getDb = async () => {
    const querySnapshot = await db.collection('Styles').get();
    let styles = [];
    querySnapshot.forEach((doc)=>{
      styles.push(doc.data());
    })
    this.setState({
      styles: styles
    });
  }
  componentDidMount() {
    this.getDb();
  }

  SelectStyle = (e) => {
    const styleId = e.currentTarget.className.split(' ')[0];
    const index = e.currentTarget.className.split(' ')[1];
    const { width, height } = this.state.styles[index];
    this.setState({
      styleId: styleId,
      width: width,
      height: height
    });
  }

  StyleList = () => {
    const { styles } = this.state;
    const styleList = styles.map((style, index) => (
      <div className={`${style.name} ${index} style`} key={style.name} onClick={this.SelectStyle}>
        <img src={style.imageUrl} alt=""/>
        {/* <div>{style.name}</div> */}
      </div>
    ))
    return styleList;
  }

  render() {
    const { styles, styleId, width, height } = this.state;
    return (
      <div className="App">
        <h1>Select NameCard Style</h1>
        <StyleList className="style-list">
          {styles && this.StyleList()}
        </StyleList>

        {styleId && <Redirect
          to={{
            pathname: `/${styleId}`,
            state: { 
              styledId: styleId,
              width: width,
              height: height
             }
          }}
        />}

      </div>
    );
  }
}

export default SelectStyle;